module.exports = __webpack_public_path__ + "img/revenue.507225e5.png";